document.addEventListener('DOMContentLoaded', function() {
  // Feature definitions - centralized configuration
  const FEATURES = {
    dimensions: { title: 'Dimensions', type: 'category' },
    width: { title: 'Width', type: 'dimension', metafield: 'width' },
    depth: { title: 'Depth', type: 'dimension', metafield: 'depth' },
    height: { title: 'Height', type: 'dimension', metafield: 'height' },
    desktop_height: { title: 'Desktop Height', type: 'dimension', metafield: 'desktop_height' },
    maximum_load: {
      title: 'Weight Capacity',
      type: 'weight',
      metafield: 'maximum_load'
    },
    features: { title: 'Features', type: 'category' },
    keyboard_tray: {
      title: 'Adjustable Keyboard Tray',
      mobileTitle: 'Adjustable Keyboard Tray',
      description: 'Width x Depth x Height',
      type: 'keyboard_dimensions',
      metafield: 'keyboard_tray_dimensions'
    },
    reinforced_rail: {
      title: 'Reinforced Rail System (RRS)',
      description: 'Reinforced rails for heavy keyboards without flex or sag',
      type: 'keyboard_tray_check'
    },
    sit_stand: { title: 'Sit-stand Workstation', type: 'feature', featureKey: 'motorized_leg' },
    // adjustable_desktop: {
    //   title: 'Adjustable Desktop Height',
    //   description: 'The desktop height can be adjusted at the feet to 74/76/78 cm',
    //   type: 'feature',
    //   featureKey: 'adjustable_desktop'
    // },
    split_desktop: { title: 'Split-level Desktop', type: 'feature', featureKey: 'split_desktop' },
    ssl_controller: { title: 'SSL Controller Slot', type: 'feature', featureKey: 'controller_slot' },
    cut_out: { title: 'Cut-out Desktop', type: 'feature', featureKey: 'cut_out' },
    speaker_shelf: { title: 'Speaker Shelf', type: 'feature', featureKey: 'speaker_shelf' },
    flat_shelves: { title: 'Flat Shelves', type: 'feature', featureKey: 'flat_shelf' },
    cable_management: {
      title: 'Integrated Cable Management',
      type: 'feature',
      featureKey: 'cable_management'
    },
    optional_shelf: {
      title: 'Optional Monitor Shelf',
      description: 'Add a shelf between the racks for screens or monitors',
      type: 'feature',
      featureKey: 'optional_shelf'
    },
    modular_design: {
      title: 'Modular Design',
      type: 'feature',
      featureKey: 'modular_design'
    },
    racks: { title: 'Racks', type: 'category' },
    rack_space: { title: 'Built-in Rack Space', type: 'text', metafield: 'rackunits' },
    rack_kit: {
      title: 'Rack Kit Compatibility',
      description: 'Expandable with an additional 2x10U',
      type: 'feature',
      featureKey: 'rack_kit'
    },
    cover_panel: { title: 'Cover Panel Compatibility', type: 'feature', featureKey: 'cover_panel' },
    product_info: { title: 'Product Info', type: 'product_info' }
  };

  let allProducts = [];
  let maxProducts = 3;
  let isUpdating = false; // Flag to prevent multiple simultaneous updates

  // Helper functions
  // Sharp images on high-density screens: offer the browser several widths of the same Shopify image
  function imageSrcset(url) {
    if (!url || !/[?&]width=\d+/.test(url)) return '';
    return [600, 900, 1200, 1600].map(function (w) { return url.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w'; }).join(', ');
  }
  function imageTag(url, alt, cls, sizes) {
    var set = imageSrcset(url);
    return '<img src="' + url + '"' + (set ? ' srcset="' + set + '" sizes="' + sizes + '"' : '') + ' alt="' + alt + '"' + (cls ? ' class="' + cls + '"' : '') + ' loading="lazy" decoding="async">';
  }

  function getSvgContent(templateId) {
    const template = document.getElementById(templateId);
    return template ? template.innerHTML : '';
  }

  function isTrue(value) {
    if (value === null || value === undefined) return false;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
      const lowerValue = value.toLowerCase().trim();
      return lowerValue === 'true' || lowerValue === '1' || lowerValue === 'yes' || lowerValue === 'on';
    }
    if (typeof value === 'number') return value === 1;
    return false;
  }

  function getFeatureKeys(product) {
    const keys = product?.metafields?.feature_keys;
    if (!keys) return [];
    if (Array.isArray(keys)) return keys;
    if (typeof keys === 'string') {
      return keys.split(',').map((key) => key.trim()).filter(Boolean);
    }
    return [];
  }

  function hasFeature(product, featureKey) {
    return getFeatureKeys(product).includes(featureKey);
  }

  function normalizeProductMetafields(product) {
    if (product && product.metafields) {
      const allMetafields = [
        'feature_keys',
        'width', 'depth', 'height', 'desktop_height', 'keyboard_tray_dimensions',
        'rackunits', 'maximum_load'
      ];

      allMetafields.forEach(field => {
        if (product.metafields[field] === undefined) {
          product.metafields[field] = null;
        }
      });
    } else if (product) {
      product.metafields = {};
    }
    return product;
  }

  function hasKeyboardTray(product) {
    const dimensions = parseKeyboardDimensions(product.metafields?.keyboard_tray_dimensions);
    return !!(dimensions && dimensions.every(d => d && d !== '(X)' && d.trim() !== ''));
  }

  function anyVisibleProductHasKeyboardTray() {
    return allProducts.slice(0, maxProducts).some(hasKeyboardTray);
  }

  function parseKeyboardDimensions(dimensionsString) {
    if (!dimensionsString) return null;
    
    let dimensions;
    if (typeof dimensionsString === 'string' && dimensionsString.startsWith('[')) {
      try {
        dimensions = JSON.parse(dimensionsString);
      } catch (e) {
        dimensions = dimensionsString.split(',').map(d => d.trim());
      }
    } else {
      dimensions = dimensionsString.split(',').map(d => d.trim());
    }
    
    return dimensions.map(d => (d || '(X)').replace(/["\[\]]/g, '').trim());
  }

  // Initialize product data with enhanced error handling
  function initializeProductData() {
    if (!window.productData) {
      return false;
    }

    // Check if current product exists and has required fields
    if (window.productData.current) {
      const currentProduct = window.productData.current;
      
      // Validate current product has minimum required data
      if (!currentProduct.id || !currentProduct.title) {
        return false;
      }
      
      allProducts.push(normalizeProductMetafields(currentProduct));
    } else {
      return false;
    }
    
    // Add compare products if they exist
    if (window.productData.compare && window.productData.compare.length > 0) {
      window.productData.compare.forEach((metafieldProduct, index) => {
        if (metafieldProduct && metafieldProduct.id && metafieldProduct.title) {
          const exists = allProducts.find(p => p.id === metafieldProduct.id);
          if (!exists) {
            allProducts.push(normalizeProductMetafields(metafieldProduct));
          }
        }
      });
    }

    return allProducts.length > 0;
  }

  function getMaxProducts() {
    if (window.innerWidth <= 749) return 2;
    if (window.innerWidth <= 988) return 2;
    return 3;
  }

  function updateGridLayout() {
    const gridTemplate = `1fr ${'1fr '.repeat(maxProducts)}`;
    
    // Cache selectors to avoid repeated DOM queries
    const headerRow = document.querySelector('.comparison-table__header-row');
    const specRows = document.querySelectorAll('.comparison-table__spec-row');
    
    // Only update if the grid template would actually change
    if (headerRow && headerRow.style.gridTemplateColumns !== gridTemplate) {
      headerRow.style.gridTemplateColumns = gridTemplate;
    }
    
    specRows.forEach(row => {
      if (row.style.gridTemplateColumns !== gridTemplate) {
        row.style.gridTemplateColumns = gridTemplate;
      }
    });
  }

  // Generate feature value based on type
  function generateFeatureValue(product, feature) {
    const metafields = product.metafields || {};
    
    switch (feature.type) {
      case 'dimension':
        const dimensionData = metafields[feature.metafield];
        if (dimensionData && dimensionData.value && dimensionData.value.trim() !== '') {
          return `<p>${dimensionData.value}${dimensionData.unit || ''}</p>`;
        }
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'keyboard_dimensions':
        const dimensions = parseKeyboardDimensions(metafields.keyboard_tray_dimensions);
        if (dimensions && dimensions.every(d => d && d !== '(X)' && d.trim() !== '')) {
          return `<p>${dimensions[0]} x ${dimensions[1]} x ${dimensions[2]} cm</p>`;
        }
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'keyboard_tray_check':
        if (hasKeyboardTray(product)) {
          return `<div class="comparison-table__available">${getSvgContent('svg-available')}</div>`;
        }
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'feature':
        if (hasFeature(product, feature.featureKey)) {
          return `<div class="comparison-table__available">${getSvgContent('svg-available')}</div>`;
        }
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'boolean':
        const booleanValue = metafields[feature.metafield];
        if (booleanValue !== null && booleanValue !== undefined && isTrue(booleanValue)) {
          return `<div class="comparison-table__available">${getSvgContent('svg-available')}</div>`;
        }
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'text':
        const textValue = metafields[feature.metafield];
        if (textValue && textValue.toString().trim() !== '') {
          return `<p>${textValue}</p>`;
        }
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'weight':
        const weightValue = metafields[feature.metafield];
        if (weightValue !== null && weightValue !== undefined && weightValue.toString().trim() !== '') {
          const weightStr = weightValue.toString().trim();
          const weightDisplay = /kg/i.test(weightStr) ? weightStr : `${weightStr} kg`;
          return `<p>${weightDisplay}</p>`;
        }
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'product_info':
        return `<div class="comparison-table__product-info-display" data-product-id="${product.id}">
          <div class="comparison-table__product-name">${product.title}</div>
          ${product.price ? `<div class="price__container">
            ${product.price}
          </div>` : ''}
          ${product.url ? `<div class="comparison-table__view-details-wrapper">
            <a href="${product.url}" class="comparison-table__view-details-button">
              <span>View Details</span>
            </a>
          </div>` : ''}
        </div>`;

      default:
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;
    }
  }

  function generateProductHeader(product) {
    return `
      <div class="comparison-table__header-cell">
        <div class="comparison-table__product-card" data-product-id="${product.id}">
          <div class="comparison-table__image-wrapper">
            ${product.image ? 
              imageTag(product.image, product.title, 'comparison-table__image', '(max-width: 749px) 46vw, (max-width: 989px) 31vw, 24vw') : 
              `<div class="comparison-table__no-image">No Image</div>`}
          </div>
          <div class="comparison-table__product-info">
            <h3 class="comparison-table__product-title">${product.title}</h3>
            ${product.url ? `<div class="comparison-table__view-details-wrapper">
              <a href="${product.url}" class="comparison-table__view-details-button">
                <span>View Details</span>
              </a>
            </div>` : ''}
          </div>
          <div class="comparison-table__change-button">
            <span>Change</span>
          </div>
        </div>
      </div>
    `;
  }

  function generateFeatureRow(featureKey, feature) {
    const visibleProducts = allProducts.slice(0, maxProducts);
    
    if (feature.type === 'category') {
      return `
        <div class="comparison-table__spec-row comparison-table__spec-row--category">
          <div class="comparison-table__spec-cell--category">
            <span class="comparison-table__spec-cell--title">${feature.title}</span>
          </div>
          ${visibleProducts.map(() => '<div class="comparison-table__spec-cell"></div>').join('')}
        </div>
      `;
    }

    if (feature.type === 'product_info') {
      return `
        <div class="comparison-table__spec-row comparison-table__spec-row--product-info">
          <div class="comparison-table__spec-cell--category">&nbsp;</div>
          ${visibleProducts.map(product => `
            <div class="comparison-table__spec-cell">
              ${generateFeatureValue(product, feature)}
            </div>
          `).join('')}
        </div>
      `;
    }

    const mobileTitle = feature.mobileTitle || feature.title;
    const mobileDescription = feature.description ? `<div class="comparison-table__mobile-feature-description">${feature.description}</div>` : '';

    return `
      <div class="comparison-table__spec-row">
        <div class="comparison-table__spec-cell--category">
          <span class="comparison-table__feature">${feature.title}</span>
          ${feature.description ? `<h4 class="comparison-table__feature-description">${feature.description}</h4>` : ''}
        </div>
        ${visibleProducts.map(product => `
          <div class="comparison-table__spec-cell">
            <div class="comparison-table__mobile-feature-label">${mobileTitle}</div>
            ${mobileDescription}
            ${generateFeatureValue(product, feature)}
          </div>
        `).join('')}
      </div>
    `;
  }

  // Check if all visible products have unavailable features
  function isFeatureUnavailableForAll(featureName) {
    const visibleProducts = allProducts.slice(0, maxProducts);
    
    const featureChecks = {
      'Width': (product) => !!(product.metafields?.width?.value && product.metafields.width.value.trim() !== ''),
      'Depth': (product) => !!(product.metafields?.depth?.value && product.metafields.depth.value.trim() !== ''),
      'Height': (product) => !!(product.metafields?.height?.value && product.metafields.height.value.trim() !== ''),
      'Desktop Height': (product) => !!(product.metafields?.desktop_height?.value && product.metafields.desktop_height.value.trim() !== ''),
      'Adjustable Keyboard Tray': (product) => hasKeyboardTray(product),
      'Adjustable Desktop Height': (product) => hasFeature(product, 'adjustable_desktop'),
      'Split-level Desktop': (product) => hasFeature(product, 'split_desktop'),
      'Sit-stand Workstation': (product) => hasFeature(product, 'motorized_leg'),
      'Built-in Rack Space': (product) => {
        const value = product.metafields?.rackunits;
        return !!(value && value.toString().trim() !== '');
      },
      'Weight Capacity': (product) => {
        const value = product.metafields?.maximum_load;
        return !!(value !== null && value !== undefined && value.toString().trim() !== '');
      },
      'Rack Kit Compatibility': (product) => hasFeature(product, 'rack_kit'),
      'Cover Panel Compatibility': (product) => hasFeature(product, 'cover_panel'),
      'SSL Controller Slot': (product) => hasFeature(product, 'controller_slot'),
      'Cut-out Desktop': (product) => hasFeature(product, 'cut_out'),
      'Speaker Shelf': (product) => hasFeature(product, 'speaker_shelf'),
      'Flat Shelves': (product) => hasFeature(product, 'flat_shelf'),
      'Integrated Cable Management': (product) => hasFeature(product, 'cable_management'),
      'Optional Monitor Shelf': (product) => hasFeature(product, 'optional_shelf'),
      'Modular Design': (product) => hasFeature(product, 'modular_design'),
      'Reinforced Rail System (RRS)': (product) => hasKeyboardTray(product)
    };

    const checkFunction = featureChecks[featureName];
    if (!checkFunction) return true;

    return visibleProducts.every(product => !checkFunction(product));
  }

  function hideUnavailableRows() {
    const specRows = document.querySelectorAll('.comparison-table__spec-row:not(.comparison-table__spec-row--category)');
    
    specRows.forEach(row => {
      const featureElement = row.querySelector('.comparison-table__feature');
      if (!featureElement) return;
      
      const featureName = featureElement.textContent.trim();
      
      // Always show RRS when any compared product has a keyboard tray
      if (featureName === 'Reinforced Rail System (RRS)') {
        row.classList.toggle('comparison-table__row--hidden', !anyVisibleProductHasKeyboardTray());
        return;
      }

      // Never hide the "Built-in Rack Space" feature
      if (featureName === 'Built-in Rack Space') {
        row.classList.remove('comparison-table__row--hidden');
        return;
      }
      
      const shouldHide = isFeatureUnavailableForAll(featureName);
      row.classList.toggle('comparison-table__row--hidden', shouldHide);
    });
  }

  function generateTable() {
    if (allProducts.length === 0) {
      return;
    }
    
    maxProducts = getMaxProducts();
    const visibleProducts = allProducts.slice(0, maxProducts);

    // Generate product headers
    const headersContainer = document.getElementById('comparison-table__product-headers');
    if (headersContainer) {
      headersContainer.innerHTML = visibleProducts.map(product => generateProductHeader(product)).join('');
    }

    // Generate specifications
    const specsContainer = document.getElementById('comparison-table__specs');
    if (specsContainer) {
      specsContainer.innerHTML = Object.entries(FEATURES).map(([key, feature]) => generateFeatureRow(key, feature)).join('');
    }

    updateGridLayout();
    hideUnavailableRows();

    // Add event listeners to product cards
    const productCards = document.querySelectorAll('.comparison-table__product-card');
    
    productCards.forEach(card => {
      card.addEventListener('click', (e) => {
        // Don't open modal if clicking on view details button
        if (e.target.closest('.comparison-table__view-details-button')) {
          return;
        }
        showProductSelector(card);
      });
      
      // Handle view details button hover to hide change button
      const viewDetailsButton = card.querySelector('.comparison-table__view-details-button');
      if (viewDetailsButton) {
        viewDetailsButton.addEventListener('mouseenter', () => {
          card.classList.add('view-details-hover');
        });
        viewDetailsButton.addEventListener('mouseleave', () => {
          card.classList.remove('view-details-hover');
        });
      }
    });

    // Safari-specific optimizations
    optimizeForSafari();
  }

  function optimizeForSafari() {
    // Force hardware acceleration for Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    if (isSafari) {
      // No forced GPU layers on the cards or images: Safari rasterises those at low resolution, which made the desk photos look soft
    }
  }

  // Function to transform Shopify product data to our format
  function transformProductData(shopifyProduct) {
    // Get image - products.json returns featured_image as a URL string
    // Handle both full URLs and relative paths
    let productImage = null;
    if (shopifyProduct.featured_image) {
      // If it's already a full URL, use it; otherwise construct it
      if (shopifyProduct.featured_image.startsWith('http')) {
        productImage = shopifyProduct.featured_image;
      } else {
        // Shopify products.json returns relative URLs like "/products/image.jpg"
        // We need to construct the full CDN URL
        productImage = shopifyProduct.featured_image.startsWith('//') 
          ? `https:${shopifyProduct.featured_image}`
          : `https://cdn.shopify.com${shopifyProduct.featured_image}`;
      }
    } else if (shopifyProduct.images && shopifyProduct.images.length > 0) {
      const firstImage = shopifyProduct.images[0];
      if (typeof firstImage === 'string') {
        productImage = firstImage.startsWith('http') 
          ? firstImage
          : firstImage.startsWith('//')
          ? `https:${firstImage}`
          : `https://cdn.shopify.com${firstImage}`;
      } else if (firstImage.src) {
        productImage = firstImage.src.startsWith('http')
          ? firstImage.src
          : firstImage.src.startsWith('//')
          ? `https:${firstImage.src}`
          : `https://cdn.shopify.com${firstImage.src}`;
      }
    }

    // Note: products.json doesn't include metafields by default
    // We'll set them all to null and they can be loaded later if needed
    // For now, products will show as "unavailable" for metafield-based features
    const metafields = {
      feature_keys: '',
      width: null,
      depth: null,
      height: null,
      desktop_height: null,
      keyboard_tray_dimensions: null,
      rackunits: null,
      maximum_load: null
    };

    // Get price HTML - products.json includes variant prices
    const variant = shopifyProduct.variants && shopifyProduct.variants.length > 0 ? shopifyProduct.variants[0] : null;
    let priceHtml = '';
    if (variant) {
      const price = parseFloat(variant.price) / 100; // Shopify prices are in cents
      const comparePrice = variant.compare_at_price ? parseFloat(variant.compare_at_price) / 100 : null;
      
      if (comparePrice && comparePrice > price) {
        priceHtml = `<span class="price price--on-sale">
          <span class="price-item price-item--regular">${formatMoney(price)}</span>
          <s class="price-item price-item--sale">${formatMoney(comparePrice)}</s>
        </span>`;
      } else {
        priceHtml = `<span class="price-item price-item--regular">${formatMoney(price)}</span>`;
      }
    }

    return {
      id: String(shopifyProduct.id),
      title: shopifyProduct.title,
      image: productImage,
      url: `/products/${shopifyProduct.handle}`,
      price: priceHtml,
      product_handle: shopifyProduct.handle,
      metafields: metafields
    };
  }

  // Helper function to format money
  function formatMoney(amount) {
    // Use Shopify's money format if available, otherwise use Intl
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(amount * 100, window.money_format || '{{amount}}');
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(amount);
  }

  // Function to fetch all products from workstations collection
  async function loadAllProductsFromCollection(modal, cardIndex) {
    const collectionUrl = window.productData?.collectionUrl;
    if (!collectionUrl) {
      console.error('Collection URL not found');
      return;
    }

    const loadMoreButton = modal.querySelector('.comparison-table__load-more-button');
    const productGrid = modal.querySelector('.comparison-table__product-grid');
    
    if (loadMoreButton) {
      loadMoreButton.disabled = true;
      loadMoreButton.textContent = 'Loading...';
    }

    try {
      // Fetch products from collection
      const response = await fetch(`${collectionUrl}/products.json`);
      if (!response.ok) {
        throw new Error('Failed to fetch products');
      }

      const data = await response.json();
      const collectionProducts = data.products || [];

      // Get existing product IDs to avoid duplicates
      const existingProductIds = allProducts.map(p => String(p.id));
      const visibleProductIds = allProducts.slice(0, maxProducts).map(p => String(p.id));

      // Transform and filter products - first create basic product objects
      const productsToFetch = [];
      collectionProducts.forEach(shopifyProduct => {
        const productId = String(shopifyProduct.id);
        
        // Skip if already in allProducts
        if (existingProductIds.includes(productId)) {
          return;
        }

        // Create basic product data (will be updated with full data)
        const transformedProduct = transformProductData(shopifyProduct);
        const normalizedProduct = normalizeProductMetafields(transformedProduct);
        
        // Add to allProducts temporarily (will be updated with full data)
        allProducts.push(normalizedProduct);
        productsToFetch.push(normalizedProduct);
      });

      // Fetch full product data (including metafield images) for all products in parallel
      const fetchPromises = productsToFetch.map(async (product) => {
        try {
          const fetchedData = await fetchProductWithMetafields(product.product_handle);
          if (fetchedData) {
            const transformedData = transformFetchedProductData(fetchedData);
            const normalizedData = normalizeProductMetafields(transformedData);
            
            // Update the product in allProducts array
            const productIndex = allProducts.findIndex(p => p.id === product.id);
            if (productIndex !== -1) {
              allProducts[productIndex] = normalizedData;
            }
            
            return normalizedData;
          }
          return product;
        } catch (error) {
          console.error(`Error fetching product data for ${product.product_handle}:`, error);
          return product;
        }
      });

      // Wait for all fetches to complete
      const productsWithFullData = await Promise.all(fetchPromises);

      // Add new products to the modal (excluding visible ones)
      productsWithFullData.forEach(product => {
        const productId = String(product.id);
        if (!visibleProductIds.includes(productId)) {
          const productElement = createProductElement(product);
          productGrid.appendChild(productElement);
          
          // Add click handler
          productElement.addEventListener('click', () => {
            allProducts[cardIndex] = product;
            generateTable();
            modal.remove();
          });
        }
      });

      // Hide the load more button since we've loaded all products
      if (loadMoreButton) {
        loadMoreButton.style.display = 'none';
      }

    } catch (error) {
      console.error('Error loading products:', error);
      if (loadMoreButton) {
        loadMoreButton.disabled = false;
        loadMoreButton.textContent = 'Load More';
        loadMoreButton.style.color = '#dc2626';
        setTimeout(() => {
          loadMoreButton.style.color = '';
        }, 3000);
      }
    }
  }

  // Function to fetch full product data with metafields using product handle
  async function fetchProductWithMetafields(productHandle) {
    try {
      // Fetch product data from our custom section endpoint
      const response = await fetch(`/products/${productHandle}?section_id=product-data-json`);
      if (!response.ok) {
        return null;
      }
      
      const text = await response.text();
      
      // Shopify sections return HTML wrapped in a section tag, we need to extract the JSON
      // The JSON should be inside a script tag with id="product-data-json"
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      
      // Try to find JSON in the script tag
      const scriptTag = doc.querySelector('script#product-data-json');
      if (scriptTag && scriptTag.textContent) {
        try {
          return JSON.parse(scriptTag.textContent.trim());
        } catch (e) {
          console.error('Error parsing JSON from script tag:', e);
          return null;
        }
      }
      
      // Fallback: try to extract JSON from section content
      const sectionContent = doc.querySelector('.shopify-section') || doc.body;
      if (sectionContent) {
        const textContent = sectionContent.textContent.trim();
        const jsonMatch = textContent.match(/\{[\s\S]*\}/);
        if (jsonMatch) {
          try {
            return JSON.parse(jsonMatch[0]);
          } catch (parseError) {
            console.error('Error parsing JSON from text:', parseError);
            return null;
          }
        }
      }
      
      return null;
    } catch (error) {
      console.error('Error fetching product with metafields:', error);
      return null;
    }
  }

  // Function to transform fetched product data to our format
  function transformFetchedProductData(fetchedData) {
    if (!fetchedData) return null;

    return {
      id: String(fetchedData.id),
      title: fetchedData.title,
      image: fetchedData.image,
      url: fetchedData.url,
      price: fetchedData.price || '',
      product_handle: fetchedData.handle,
      metafields: {
        feature_keys: fetchedData.metafields?.feature_keys || '',
        width: fetchedData.metafields?.width || null,
        depth: fetchedData.metafields?.depth || null,
        height: fetchedData.metafields?.height || null,
        desktop_height: fetchedData.metafields?.desktop_height || null,
        keyboard_tray_dimensions: fetchedData.metafields?.keyboard_tray_dimensions || null,
        rackunits: fetchedData.metafields?.rackunits || null,
        maximum_load: fetchedData.metafields?.maximum_load || null
      }
    };
  }

  // Helper function to create a product element for the modal
  function createProductElement(product) {
    const productDiv = document.createElement('div');
    productDiv.className = 'comparison-table__modal-product';
    productDiv.dataset.productId = product.id;
    productDiv.innerHTML = `
      <div class="comparison-table__modal-product-image">
        ${product.image ? 
          imageTag(product.image, product.title, '', '(max-width: 749px) 45vw, 220px') : 
          `<div class="comparison-table__no-image">Product</div>`}
      </div>
      <div class="comparison-table__modal-product-info">
        <h3>${product.title}</h3>
      </div>
      <div class="comparison-table__modal-select-button">
        <span>Select</span>
      </div>
    `;
    return productDiv;
  }

  function showProductSelector(card) {
    const cardIndex = Array.from(document.querySelectorAll('.comparison-table__product-card')).indexOf(card);
    const visibleProductIds = allProducts.slice(0, maxProducts).map(p => p.id);
    const selectableProducts = allProducts.filter(product => !visibleProductIds.includes(product.id));
    
    if (selectableProducts.length === 0 && !window.productData?.collectionUrl) return;

    const modal = document.createElement('div');
    modal.className = 'comparison-table__modal';
    modal.innerHTML = `
      <div class="comparison-table__modal-content">
        <div class="comparison-table__modal-header">
          <h3>Select a Product</h3>
          <button class="comparison-table__modal-close">&times;</button>
        </div>
        <div class="comparison-table__modal-body">
          <div class="comparison-table__product-grid">
            ${selectableProducts.map(product => `
              <div class="comparison-table__modal-product" data-product-id="${product.id}">
                <div class="comparison-table__modal-product-image">
                  ${product.image ? 
                    imageTag(product.image, product.title, '', '(max-width: 749px) 45vw, 220px') : 
                    `<div class="comparison-table__no-image">Product</div>`}
                </div>
                <div class="comparison-table__modal-product-info">
                  <h3>${product.title}</h3>
                </div>
                <div class="comparison-table__modal-select-button">
                  <span>Select</span>
                </div>
              </div>
            `).join('')}
          </div>
          ${window.productData?.collectionUrl ? `
            <div class="comparison-table__load-more-wrapper">
              <button class="comparison-table__load-more-button">Load More</button>
            </div>
          ` : ''}
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    
    // Event handlers
    modal.querySelector('.comparison-table__modal-close').addEventListener('click', () => modal.remove());
    modal.addEventListener('click', (e) => e.target === modal && modal.remove());
    
    modal.querySelectorAll('.comparison-table__modal-product').forEach(productElement => {
      productElement.addEventListener('click', async () => {
        const newProductId = productElement.dataset.productId;
        const newProduct = allProducts.find(p => p.id === newProductId);
        if (newProduct) {
          // Show loading state
          productElement.style.opacity = '0.6';
          productElement.style.pointerEvents = 'none';
          
          // If product doesn't have metafields loaded, try to fetch them
          const hasMetafields = newProduct.metafields && 
            Object.values(newProduct.metafields).some(val => val !== null);
          
          if (!hasMetafields && newProduct.product_handle) {
            try {
              const fetchedData = await fetchProductWithMetafields(newProduct.product_handle);
              if (fetchedData) {
                const transformedData = transformFetchedProductData(fetchedData);
                const normalizedData = normalizeProductMetafields(transformedData);
                allProducts[cardIndex] = normalizedData;
              } else {
                allProducts[cardIndex] = newProduct;
              }
            } catch (error) {
              console.error('Error fetching product data:', error);
              allProducts[cardIndex] = newProduct;
            }
          } else {
            allProducts[cardIndex] = newProduct;
          }
          generateTable();
        }
        modal.remove();
      });
    });

    // Load More button handler
    const loadMoreButton = modal.querySelector('.comparison-table__load-more-button');
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', (e) => {
        e.stopPropagation();
        loadAllProductsFromCollection(modal, cardIndex);
      });
    }
  }

  function addMobileHandlers() {
    const mobileButtons = [
      '.comparison-table__compare-more-link-button',
      '.comparison-table__compare-more-full-button'
    ];
    
    mobileButtons.forEach(selector => {
      const button = document.querySelector(selector);
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const firstProductCard = document.querySelector('.comparison-table__product-card');
          if (firstProductCard) showProductSelector(firstProductCard);
        });
      }
    });
  }

  // Initialize with error handling
  const initializationSuccess = initializeProductData();
  
  if (!initializationSuccess) {
    // Show a fallback message or hide the table container
    const container = document.querySelector('.comparison-table__container');
    if (container) {
      container.innerHTML = '<div style="text-align: center; padding: 2rem; color: #666;">Comparison data not available for this product.</div>';
    }
    return;
  }
  
  setTimeout(() => {
    generateTable();
    addMobileHandlers();
  }, 100);

  // Handle resize with debouncing to prevent flashing
  let resizeTimeout;
  let lastMaxProducts = maxProducts;
  
  window.addEventListener('resize', () => {
    if (isUpdating) return; // Prevent multiple simultaneous updates
    
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newMaxProducts = getMaxProducts();
      
      // Only regenerate if the number of visible products actually changes
      if (newMaxProducts !== lastMaxProducts) {
        lastMaxProducts = newMaxProducts;
        isUpdating = true;
        generateTable();
        isUpdating = false;
      } else {
        // Just update the grid layout without regenerating content
        updateGridLayout();
      }
    }, 150); // 150ms debounce delay
  });
}); 